import { CSSProperties, ReactNode, useMemo } from 'react'
import type { ButtonProps } from './Button.types'
import CircularProgress from '../CircularProgress'

type ButtonSize = Required<ButtonProps>['size']

export type LoadingWrapperProps = Pick<ButtonProps, 'loadingIconSize' | 'style' | 'size'> & {
  children: ReactNode
  innerStyle?: CSSProperties
}

const LoadingWrapper = ({
  children,
  loadingIconSize,
  style,
  innerStyle,
  size,
}: LoadingWrapperProps) => {
  const loadingSizeMap = useMemo<{ [key in ButtonSize]: number }>(
    () => ({
      xSmall: 14,
      small: 18,
      medium: 24,
      large: 28,
      xLarge: 32,
    }),
    [],
  )

  const loadingSize = useMemo(() => {
    if (loadingIconSize) return loadingIconSize
    return loadingSizeMap[size!]
  }, [loadingIconSize, loadingSizeMap, size])

  return (
    <span style={{ position: 'relative', ...style, ...innerStyle }}>
      <span style={{ visibility: 'hidden', ...innerStyle }}>{children}</span>
      <CircularProgress
        color="gray"
        size={loadingSize}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          marginTop: `-${loadingSize / 2}px`,
          marginLeft: `-${loadingSize / 2}px`,
        }}
      />
    </span>
  )
}

export default LoadingWrapper
